import React from 'react';
import type ProductsJswConfigurationType from '@atlassian/jira-spa-apps-products-jsw-configuration/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazySystemConfigurationGeneral = lazyForPaint<typeof ProductsJswConfigurationType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-system-configuration-general", jiraSpaEntry: "async-system-configuration-general" */ '@atlassian/jira-spa-apps-system-configuration-general'
			),
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazySystemConfigurationGeneral}
		pageId="system-configuration-general"
		shouldShowSpinner={false}
	/>
);
